/**
 * LoadingState component
 * Displays a loading spinner with optional message
 */

import { Loader2 } from 'lucide-react';

export interface LoadingStateProps {
  /** Optional loading message (defaults to "Loading...") */
  message?: string;
}

/**
 * LoadingState - Displays animated spinner with message
 */
export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
      <p className="text-sm text-gray-500 mt-4">{message}</p>
    </div>
  );
}
